"use client";
import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";

import {
  RecommendationProduct,
  RecommendationResponse,
  RecommendationProps,
} from "./recommendations.type";

export const getRecommendations = async ({
  chameleonRequestInstance,
  authHeaderValue: authHeader,
  country,
  store,
  shop,
  lang,
  currency,
  productids,
  type = "ymal",
  limit = 16,
}: RecommendationProps & {
  chameleonRequestInstance: ChameleonRequest;
  authHeaderValue: string;
  type?: "ymal" | "pab";
}): Promise<RecommendationResponse> => {
  if (!productids.length) {
    throw new Error("No product IDs provided for recommendations request.");
  }

  const url = getApiUrl({
    path: `/customer/recommendation/v4/customer/me/alike`,
    searchParams: {
      productids: productids.join(","),
      lang,
      country,
      currency,
      store,
      shop,
      type: type === "pab" ? "complementary" : type,
      limit: limit.toString(),
      expand: "products",
    },
  });

  const response = await chameleonRequestInstance.get<RecommendationResponse>(
    url,
    {
      headers: {
        Authorization: authHeader,
      },
    },
    {
      requestType: "RECOMMENDATIONS_API",
    },
  );

  return {
    ...response.data,
    recommendations: response.data.recommendations.slice(0, limit),
  };
};

export type { RecommendationProduct, RecommendationProps };
